import $ from 'jquery';
import scrollMonitor from 'scrollmonitor';
import clamp from 'clamp-js';
import autosize from 'autosize';
import Flickity from 'flickity';
import Contact from './components/Contact';
import InterventionMap from './components/InterventionMap';
import Lines from './components/Lines';
import MapTooltip from './components/MapTooltip';
import Mosaic from './components/Mosaic';
import Quicklinks from './components/Quicklinks';
import ScrollingList from './components/ScrollingList';
import Steps from './components/Steps';
import TabbedContent from './components/TabbedContent';
import Timeline from './components/Timeline';
import Menu from './components/Menu';
import Offers from './components/Offers';
import Apply from './components/Apply';
import PopupYoutubeVideo from './components/PopupYoutubeVideo';
import FacebookFeed from './components/FacebookFeed';

// initialisation
$(document).ready(() => {
  $(".js-mosaic").each((index, el) => {
    new Mosaic(el);
  });
  $(".js-intervention-map").each((index, el) => {
    new InterventionMap(el);
  });
  $(".js-quicklinks").each((index, el) => {
    new Quicklinks(el);
  });
  $(".js-timeline").each((index, el) => {
    new Timeline(el);
  });
  $(".js-map-tooltiped").each((index, el) => {
    new MapTooltip(el);
  });
  $(".js-scrolling-list").each((index, el) => {
    new ScrollingList(el);
  });
  $('.js-clamp').each((i, el) => {
    clamp(el, { clamp: $(el).data('clamp') });
  });
  $('.js-menu-toggle').on("click", (event) => {
    $("body").toggleClass('has-open-menu');
    $("html").toggleClass('has-open-menu');
    event.preventDefault();
  });
  $('.js-tabbed-content').each((index, el) => {
    new TabbedContent(el);
  });
  $('.js-flipflop').each((index, el) => {
    $(el).height($(el).height())
  })
  $('.js-flipflop').on("click", (event) => {
    if ($(event.currentTarget).hasClass('is-active')) {
      $(event.currentTarget).height($(event.currentTarget).find('.b-faq__question__title').first().height() + 36);
    }
    else {
      $(event.currentTarget).height($(event.currentTarget).find('.b-faq__question__title').first().height() + 36 + $(event.currentTarget).find('.b-faq__question__content').first().height() + 36);
    }
    $(event.currentTarget).toggleClass('is-active');

    event.preventDefault();
  });
  $('h1, h2, h3, p, .js-reveal').each((i, el) => {
    if ($(el).data("has-init-js-reveal")) {
      return;
    }
    else {
      $(el).data("has-init-js-reveal", true);
      const watcher = scrollMonitor.create(el, 0);
      watcher.enterViewport(function () {
        $(el).addClass("is-visible");
      });
      // watcher.exitViewport(function() {

      //   $(el).removeClass("is-visible");

      // });
    }
  });
  $('.js-modal__toggle').on("click", (event) => {
    const $modal = $(event.currentTarget).closest('.js-modal');
    $modal.toggleClass('is-modal-visible');
    if ($modal.hasClass('is-modal-visible')) {
      $("body").addClass('has-open-modal');
      $(window).trigger("resize");
    } else {
      $("body").removeClass('has-open-modal');
    }
    if (!$modal.attr('no-scroll')) {
      $('html, body').stop().animate({
        scrollTop: $modal.offset().top - 80,
      }, 450);
    }
    event.preventDefault();
  });
  $('.js-contact').each((index, el) => {
    new Contact(el);
  });
  $('.js-menu').each((index, el) => {
    new Menu(el);
  });
  $('.js-steps').each((index, el) => {
    new Steps(el);
  });
  $('.js-slider-fade').each((index, el) => {
    $(el).flkty = new Flickity(el, {
      prevNextButtons: false,
      groupCells: 6,
      setGallerySize: true,
      pageDots: false,
      autoPlay: true,
      adaptiveHeight: true,
    });
  });

  autosize(document.querySelectorAll('textarea'));
  var reg = /^\/rejoignez-nous\/liste-des-offres\/?/;
  if (!reg.test(window.location.pathname)) {
    new Lines();
  }

  Offers.init()

  $('.js-apply-toggle').each((index, el) => {
    new Apply(el);
  });

  $('.facebook-feed').each((index, el) => {
    new FacebookFeed(el);
  });

  $('.youtube-video-popup').each((index, el) => {
    new PopupYoutubeVideo(el);
  });

  window.addEventListener('tac.open_alert', function() {
    document.body.classList.add('has-scroll-locked');
  });

  window.addEventListener('tac.open_panel', function() {
    document.body.classList.add('has-scroll-locked');
  });

  window.addEventListener('tac.close_alert', function() {
    const customCookiesParamsModal = document.querySelector('#tarteaucitronRoot #tarteaucitron');
    if(customCookiesParamsModal.style.display !== "block") {
      document.body.classList.remove('has-scroll-locked');
    }
  });

  window.addEventListener('tac.close_panel', function() {
    const rootCookiesModal = document.querySelector('#tarteaucitronRoot');
    if(!rootCookiesModal.classList.contains('tarteaucitronBeforeVisible')) {
      document.body.classList.remove('has-scroll-locked');
    }
  });
});



// WEBPACK FOOTER //
// ./scripts/main.js